import './Tabs.scss';

import { Tab, TabNavigation } from '@hulu/react-style-components';
import { bem } from 'mission-control-common-components';

const [block] = bem('tabs');

export type PreviewTab = {
  title: string;
  component: React.ReactNode;
};

type Props = {
  tabs: PreviewTab[];
};

const Tabs = ({ tabs }: Props): React.JSX.Element => {
  return (
    <TabNavigation className={block()}>
      {tabs.map(({ title, component }) => (
        <Tab key={title} title={title}>
          {component}
        </Tab>
      ))}
    </TabNavigation>
  );
};

export default Tabs;
